module.exports = __webpack_public_path__ + "img/14.72d816ca.jpg";